import qs from "qs";

import {
  Email,
  Facebook,
  LinkedIn,
  Telegram,
  Twitter,
  WhatsApp,
} from "@/assets/icons/icons";

export const useGetLinks = (
  title: string,
  text: string,
  referralLink?: string,
) => {
  const createURL = (baseURL: string, params: any) =>
    `${baseURL}?${qs.stringify(params)}`;

  return [
    {
      icon: <Facebook />,
      link: createURL("https://facebook.com/sharer/sharer.php", {
        u: referralLink,
      }),
    },
    {
      icon: <Twitter />,
      link: createURL("https://x.com/intent/post", {
        url: referralLink,
        text,
      }),
    },
    {
      icon: <LinkedIn />,
      link: createURL("https://www.linkedin.com/shareArticle", {
        mini: true,
        url: referralLink,
        source: referralLink,
        title: text,
        summary: text,
      }),
    },
    {
      icon: <WhatsApp />,
      link: createURL("https://web.whatsapp.com/send", {
        text: `${text} ${referralLink}`,
      }),
    },
    {
      icon: <Telegram />,
      link: createURL("https://telegram.me/share/url", {
        url: referralLink,
        text,
      }),
    },
    {
      icon: <Email />,
      link: createURL("mailto:", {
        subject: title,
        body: `${text}\n${referralLink}`,
      }),
    },
  ];
};
